export default {
  MOVEMENT: {
    UP: `UP`,
    DOWN: `DOWN`,
    NONE: `NONE`,
  },
  GENDER: {
    ALL: `ALL`,
    MALE: `MALE`,
    FEMALE: `FEMALE`,
  },
}
